import close from './popover.close.directive';

export default {
    close
};
